import { UserManager } from 'oidc-client-ts'
import {
  LOCALSTORAGE_IDENTITY_PREFIX,
  LOCALSTORAGE_IDENTITY_PREFIX_LANDING,
  LOCALSTORAGE_IDENTITY_PREFIX_MS,
  LOCALSTORAGE_IDENTITY_PREFIX_PREEMPTION,
} from 'shared/constants/localStorageVariables'

export const cleanup = () => {
  // Calculate the length once to avoid recalculating it every iteration
  const length = localStorage.length

  // Use a reverse loop to safely remove items without affecting the iteration
  for (let i = length - 1; i >= 0; i--) {
    const key = localStorage.key(i)
    if (
      key &&
      (key.includes(LOCALSTORAGE_IDENTITY_PREFIX) ||
        key.includes(LOCALSTORAGE_IDENTITY_PREFIX_LANDING) ||
        key.includes(LOCALSTORAGE_IDENTITY_PREFIX_MS) ||
        key.includes(LOCALSTORAGE_IDENTITY_PREFIX_PREEMPTION))
    ) {
      localStorage.removeItem(key)
    }
  }
  new UserManager({} as any).clearStaleState()
}
